export const OktaClientId = '0oa15aymctiioGwei697'
export const ENV = 'training2' as string
export const OVERSIGHT_ENV_NAME = 'oversight-training'
export const GCS_ENV_NAME = 'training2'
export const SUBDOMAIN_SUFFIX = 'gcs-training'
